

/**
 * @name FileUploadsController
 * @description The controller invoked when editing a project through a modal instance
 * @param {Unknown} InkImage Unknown
 * @param {Unknown} AlertMessages The alert messages service
 */
function FileUploadsController(
  InkImage,
  AlertMessages
) {
  let vm = this;
  vm.$onInit = function() {
    vm.uploadFile = uploadFile;
    vm.removeFile = removeFile;
  };

/**
 * @description Upload a File
 * @param {array} files The files to upload
 * @param {array} errFiles Unknown
 * @param {array} uploadArray The array to append uploaded files to
 */
  function uploadFile(files, errFiles, uploadArray) {
    if (errFiles.length > 0) {
      AlertMessages.add({
        msg: 'Sorry, that file won’t work: ' + errFiles[0].$error +
        ' - ' + errFiles[0].$errorParam,
        type: 'danger'
      });
    } else {
      InkImage.uploadFile(files, errFiles, uploadArray);
    }
  }

/**
 * @description Remove a File
 * @param {Unknown} index The index of the file to remove
 * @param {file} file the file for the photo to be removed
 * @param {array} uploadArray The array where the file was stored
 */
  function removeFile(index, file, uploadArray) {
    InkImage.deleteImage(file).then(function() {
      uploadArray.splice(index, 1);
    }, function() {
      AlertMessages.add({
        msg: 'There was a problem deleting this image.',
        type: 'danger'
      });
    });
  }
}

angular
  .module('inkfinder')
  .controller('FileUploadsController', FileUploadsController);



// WEBPACK FOOTER //
// ./components/file-uploads/file-uploads.controller.js